import { useState, useEffect } from "react";
import { 
  saveItemGroup3, 
  getAllItemGroups, 
  getItemGroups1ByItemGroupCode, 
  getItemGroups2ByItemGroup1 
} from "../Api/ItemGroup3";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ItemGroup3 = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [itemGroups, setItemGroups] = useState([]);
  const [itemGroups1, setItemGroups1] = useState([]);
  const [itemGroups2, setItemGroups2] = useState([]);
  const [itemGroup3Data, setItemGroup3Data] = useState({
    code: "",
    description: "",
    itemGroupCode: "",
    itemGroup1: "",
    itemGroup2: ""
  });

  // Fetch item groups for dropdown
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const groups = await getAllItemGroups();
        setItemGroups(groups);
      } catch (error) {
        toast.error("Failed to load item groups");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fetch item groups 1 when item group code changes
  useEffect(() => {
    const fetchItemGroups1 = async () => {
      if (itemGroup3Data.itemGroupCode) {
        setLoading(true);
        try {
          const groups1 = await getItemGroups1ByItemGroupCode(itemGroup3Data.itemGroupCode);
          setItemGroups1(groups1);
          // Reset itemGroup1 and itemGroup2 when itemGroupCode changes
          setItemGroup3Data(prev => ({ 
            ...prev, 
            itemGroup1: "",
            itemGroup2: "" 
          }));
          setItemGroups2([]);
        } catch (error) {
          toast.error("Failed to load item groups 1");
          setItemGroups1([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroups1([]);
        setItemGroups2([]);
      }
    };

    fetchItemGroups1();
  }, [itemGroup3Data.itemGroupCode]);

  // Fetch item groups 2 when item group 1 changes
  useEffect(() => {
    const fetchItemGroups2 = async () => {
      if (itemGroup3Data.itemGroup1) {
        setLoading(true);
        try {
          const groups2 = await getItemGroups2ByItemGroup1(itemGroup3Data.itemGroup1);
          setItemGroups2(groups2);
          // Reset itemGroup2 when itemGroup1 changes
          setItemGroup3Data(prev => ({ ...prev, itemGroup2: "" }));
        } catch (error) {
          toast.error("Failed to load item groups 2");
          setItemGroups2([]);
        } finally {
          setLoading(false);
        }
      } else {
        setItemGroups2([]);
      }
    };

    fetchItemGroups2();
  }, [itemGroup3Data.itemGroup1]);

  const handleChange = (e) => {
    setItemGroup3Data({ ...itemGroup3Data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId;
    
    try {
      await saveItemGroup3(itemGroup3Data, userId);
      toast.success("🦄 Item Group 3 Added Successfully");
      setItemGroup3Data({
        code: "",
        description: "",
        itemGroupCode: "",
        itemGroup1: "",
        itemGroup2: ""
      });
      navigate("/viewItemGroup3"); 
    } catch (error) {
      toast.error(error.message || "🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Item Group 3</h2>

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="code"
                    value={itemGroup3Data.code}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Description <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="description"
                    value={itemGroup3Data.description}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Item Group <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="itemGroupCode"
                    value={itemGroup3Data.itemGroupCode}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Item Group</option>
                    {itemGroups.map((group) => (
                      <option key={group.code} value={group.code}>
                        {group.code} - {group.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Item Group 1 <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="itemGroup1"
                    value={itemGroup3Data.itemGroup1}
                    onChange={handleChange}
                    required
                    disabled={!itemGroup3Data.itemGroupCode}
                  >
                    <option value="">Select Item Group 1</option>
                    {itemGroups1.map((group) => (
                      <option key={group.code} value={group.code}>
                        {group.code} - {group.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Item Group 2 <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="itemGroup2"
                    value={itemGroup3Data.itemGroup2}
                    onChange={handleChange}
                    required
                    disabled={!itemGroup3Data.itemGroup1}
                  >
                    <option value="">Select Item Group 2</option>
                    {itemGroups2.map((group) => (
                      <option key={group.code} value={group.code}>
                        {group.code} - {group.description}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button variant="primary" type="submit" className="fields-submit">
                Save Item Group 3
              </Button>
            </div>
          </Form>
        </Container>
      </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ItemGroup3;